import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
    HdmuiEmptyStatesComponent,
    HdmuiEmptyStatesDescriptionDirective,
    HdmuiEmptyStatesTitleDirective,
} from '@heidelberg/hdmui-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { HEI_CC_URL, LOCATION } from '@data-terminal/data-access/injection-tokens';
import { ShutdownBlockerService } from '@data-terminal/ui-smart/services/shutdown-blocker/shutdown-blocker.service';

@UntilDestroy()
@Component({
    selector: 'data-terminal-shutdown-blocker',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        HdmuiEmptyStatesComponent,
        HdmuiEmptyStatesTitleDirective,
        HdmuiEmptyStatesDescriptionDirective,
    ],
    templateUrl: './shutdown-blocker.component.html',
    styleUrl: './shutdown-blocker.component.scss',
})
export class ShutdownBlockerComponent {
    readonly #shutdownBlockerService = inject(ShutdownBlockerService);
    readonly #heiCcUrl = inject(HEI_CC_URL);
    readonly #location = inject<Location>(LOCATION);

    public isActive = false;

    constructor() {
        this.#shutdownBlockerService.blockerActive$.pipe(untilDestroyed(this)).subscribe((isActive) => {
            this.isActive = isActive;
        });
    }

    public navigateBackToPortal(): void {
        this.#location.assign(this.#heiCcUrl);
    }
}
